import { useState, useEffect } from "react";
import { useBootstrap } from "@/features/bootstrap";
import { useUpdateSettings } from "@/features/bootstrap";

export function useSettingsState() {
  const { data: user } = useBootstrap();
  const { updateSettings } = useUpdateSettings();

  const [dataUse, setDataUse] = useState(false);
  const [receiveEmailAlerts, setReceiveEmailAlerts] = useState(true);
  const [receiveReports, setReceiveReports] = useState(true);
  const [wellnessTimer, setWellnessTimer] = useState("30 seconds");
  const [adultActionImages, setAdultActionImages] = useState(false);
  const [usesCastle, setUsesCastle] = useState(false);
  const [voice, setVoice] = useState("english female");

  useEffect(() => {
    if (!user) {
      return;
    }

    setDataUse(user.dataUse ?? false);
    setReceiveEmailAlerts(user.receiveEmailAlerts ?? true);
    setReceiveReports(user.receiveReports ?? true);
    setWellnessTimer(user.wellnesstimer ?? "30 seconds");
    setAdultActionImages(user.adultActionImages ?? false);
    setUsesCastle(user.usesCastle ?? false);
    setVoice(user.voice ?? "english female");
  }, [user]);

  async function handleSettingChange(field, newValue, setLocal) {
    setLocal(newValue);

    try {
      await updateSettings({ [field]: newValue });
      return true;
    } catch {
      setLocal(user?.[field] ?? newValue);
      return false;
    }
  }

  return {
    dataUse,
    receiveEmailAlerts,
    receiveReports,
    wellnessTimer,
    adultActionImages,
    usesCastle,
    voice,
    handleSettingChange,
    setDataUse,
    setReceiveEmailAlerts,
    setReceiveReports,
    setWellnessTimer,
    setAdultActionImages,
    setUsesCastle,
    setVoice,
  };
}
